import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "lg:container mx-auto my-2 w-full" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "text-sm lg:text-lg text-primary font-bold text-center mx-4 mt-4 lg:mt-8" }, " Para visualizar su recibo de pago ingrese a continuación su número de cédula ", -1)
const _hoisted_3 = { class: "flex flex-col my-3 mx-5 lg:mx-10 xl:mx-20 2xl:mx-24 justify-center items-center" }
const _hoisted_4 = { class: "relative w-full sm:w-6/12 md:w-5/12 lg:w-4/12 xl:w-4/12 2xl:w-3/12 3xl:w-3/12 bg-white rounded border shadow-lg my-3 p-4" }
const _hoisted_5 = { class: "w-full p-4" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", { class: "w-full py-2 text-sm font-bold text-left text-primary" }, " Número de cédula ", -1)
const _hoisted_7 = { class: "mt-1 text-xs text-left text-red-500" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "py-2" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "submit",
    class: "w-full py-2 px-3 text-white text-sm font-bold rounded-lg bg-primary outline-none"
  }, " Verificar ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_Form, {
          onSubmit: _ctx.validateAccess,
          "validation-schema": _ctx.schemaCouponValidationForm
        }, {
          default: _withCtx(({ errors }) => [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", null, [
                _hoisted_6,
                _createVNode(_component_Field, {
                  name: "identification",
                  type: "text",
                  as: "input",
                  autocomplete: "off",
                  autofocus: "autofocus",
                  class: _normalizeClass(["w-full px-3 h-8 shadow-lg border-2 rounded-md outline-none", { 'border border-primary': errors.identification }])
                }, null, 8, ["class"]),
                _createElementVNode("div", _hoisted_7, _toDisplayString(errors.identification), 1)
              ]),
              _hoisted_8
            ])
          ]),
          _: 1
        }, 8, ["onSubmit", "validation-schema"])
      ])
    ])
  ]))
}